export default __webpack_public_path__ + "static/media/card_img_3_3.3b5cce45.png";